define("settings/components/downgrade/linkinbio-page", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr class="u--p__tb">
    <td>
      <div class="u--block u--clearfix">
        <div class="u--float--left o--user">
          {{#if this.avatarUrl}}
            <span class="o--user__avatarProfile">
              <img
                alt={{@linkinbioPage.urlName}}
                class="o--user__avatar u--m__0"
                data-test-id={{@linkinbioPage.id}}
                draggable="false"
                ondragstart="return false;"
                src={{@linkinbioPage.avatarUrl}}
                title={{@linkinbioPage.urlName}}
              />
            </span>
          {{else}}
            <span>
              <img
                alt={{@linkinbioPage.urlName}}
                class="o--user__avatar"
                data-test-id={{@linkinbioPage.id}}
                draggable="false"
                ondragstart="return false;"
                src="/assets/images/img--userAvatar--placeholder.svg"
                title={{@linkinbioPage.urlName}}
              />
            </span>
          {{/if}}
          <span class="o--user__title">
            <span class="u--ellipsis">
              {{@linkinbioPage.headerName}}
            </span>
          </span>
          <span class="o--user__desc">
            {{@linkinbioPage.urlFormatted}}
          </span>
        </div>
  
        <Shared::Ui::Button
          @onClick={{perform @deleteLinkinbioPage @linkinbioPage}}
          @text={{t "shared_words.delete"}}
          @variant="outline"
          class="u--float--right"
          data-test-id="delete-linkinbio-page-button"
        />
      </div>
    </td>
  </tr>
  */
  {
    "id": "Xo/6z3Zp",
    "block": "[[[10,\"tr\"],[14,0,\"u--p__tb\"],[12],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--block u--clearfix\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--float--left o--user\"],[12],[1,\"\\n\"],[41,[30,0,[\"avatarUrl\"]],[[[1,\"          \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n            \"],[10,\"img\"],[15,\"alt\",[30,1,[\"urlName\"]]],[14,0,\"o--user__avatar u--m__0\"],[15,\"data-test-id\",[30,1,[\"id\"]]],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[15,\"src\",[30,1,[\"avatarUrl\"]]],[15,\"title\",[30,1,[\"urlName\"]]],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[12],[1,\"\\n            \"],[10,\"img\"],[15,\"alt\",[30,1,[\"urlName\"]]],[14,0,\"o--user__avatar\"],[15,\"data-test-id\",[30,1,[\"id\"]]],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[14,\"src\",\"/assets/images/img--userAvatar--placeholder.svg\"],[15,\"title\",[30,1,[\"urlName\"]]],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[10,1],[14,0,\"o--user__title\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"u--ellipsis\"],[12],[1,\"\\n            \"],[1,[30,1,[\"headerName\"]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"o--user__desc\"],[12],[1,\"\\n          \"],[1,[30,1,[\"urlFormatted\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,1],[[24,0,\"u--float--right\"],[24,\"data-test-id\",\"delete-linkinbio-page-button\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,2],[[30,2],[30,1]],null],[28,[37,3],[\"shared_words.delete\"],null],\"outline\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@linkinbioPage\",\"@deleteLinkinbioPage\"],false,[\"if\",\"shared/ui/button\",\"perform\",\"t\"]]",
    "moduleName": "settings/components/downgrade/linkinbio-page.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});